const PL = {
  listedPublicCompany: [
    "spółka akcyjna (S.A.)"
  ],
  nonProfit: [
    "fundacja",
    "stowarzyszenie i związki stowarzyszeń",
    "spółka z ograniczoną odpowiedzialnością"
  ],
  privateCompany: [
    "spółka z ograniczoną odpowiedzialnością (Sp. z.o.o.)",
    "prosta spółka akcyjna (PSA)",
    "przedsiębiorstwa państwowe (SOE)"
  ]
};
export {
  PL as default
};
